import React from 'react';
import classnames from 'classnames';
import Layout from "../../../../core/layout";
import Media from "../../../../core/media";
import { widths, directions } from "../../../../../enums";
import { Avatar, MessagePlaceholder, SharingContent, NetworkActions } from "../common";
import SharingConstants from "../../constants";

var FacebookSharePreviewTemplate = function FacebookSharePreviewTemplate(p) {
  var _classnames;

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('sharing-schematic-preview', (_classnames = {}, _classnames["preview-" + p.network] = p.network, _classnames))
  }, /*#__PURE__*/React.createElement(Layout, {
    columns: widths.ONE
  }, /*#__PURE__*/React.createElement(Avatar, {
    title: SharingConstants.PREVIEW_CONFIG[p.name].userName,
    byline: "1 minute ago via Your App Name",
    network: p.network,
    name: p.name
  }), /*#__PURE__*/React.createElement(MessagePlaceholder, {
    text: p.messagePlaceholder
  }), /*#__PURE__*/React.createElement(Layout, {
    columns: widths.ONE,
    borders: directions.ALL
  }, p.previewData.picture ? /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(Media, {
    reference: p.previewData.picture
  })) : null, /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(SharingContent, {
    title: p.previewData.title,
    message: p.previewData.message
  }))), /*#__PURE__*/React.createElement(NetworkActions, {
    network: p.network
  })));
};

export default FacebookSharePreviewTemplate;
//# sourceMappingURL=facebook.js.map